import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _omit from 'lodash/omit';
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveIframe } from '@zillow/zrs-cms';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';

var _excluded = ["width", "height", "url", "videoId", "autoplay", "controls", "loop", "dnt", "loading"];
var BlockVimeo = function BlockVimeo(_ref) {
  var attrs = _ref.attrs;
  var _attrs$width = attrs.width,
    width = _attrs$width === void 0 ? 1024 : _attrs$width,
    _attrs$height = attrs.height,
    height = _attrs$height === void 0 ? 768 : _attrs$height;
    attrs.url;
    var videoId = attrs.videoId,
    _attrs$autoplay = attrs.autoplay,
    autoplay = _attrs$autoplay === void 0 ? 0 : _attrs$autoplay,
    _attrs$controls = attrs.controls,
    controls = _attrs$controls === void 0 ? 1 : _attrs$controls,
    _attrs$loop = attrs.loop,
    loop = _attrs$loop === void 0 ? 0 : _attrs$loop,
    _attrs$dnt = attrs.dnt,
    dnt = _attrs$dnt === void 0 ? 0 : _attrs$dnt,
    _attrs$loading = attrs.loading,
    loading = _attrs$loading === void 0 ? 'lazy' : _attrs$loading,
    iframeAttributes = _objectWithoutProperties(attrs, _excluded);

  // Create vimeo url.
  var embedUrl = new URL("https://player.vimeo.com/video/" + videoId);
  embedUrl.searchParams.append('autoplay', autoplay ? '1' : '0');
  embedUrl.searchParams.append('muted', autoplay ? '1' : '0');
  embedUrl.searchParams.append('loop', loop ? '1' : '0');
  embedUrl.searchParams.append('controls', controls ? '1' : '0');
  embedUrl.searchParams.append('dnt', dnt ? '1' : '0');
  var isPost = usePlacement() === 'post';
  return /*#__PURE__*/React.createElement(ResponsiveIframe, _extends({
    src: embedUrl.href,
    allowFullScreen: true,
    loading: loading,
    width: width,
    height: height
  }, _omit(iframeAttributes, 'margin'), isPost ? {
    marginBottom: 'md'
  } : iframeAttributes.margin));
};
BlockVimeo.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    videoId: PropTypes.number,
    autoplay: PropTypes.bool,
    controls: PropTypes.bool,
    loop: PropTypes.bool,
    dnt: PropTypes.bool,
    loading: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var Vimeo = BlockVimeo;

export { Vimeo as default };
